import { createAction } from 'redux-act';

export const setLobbySuccess = createAction<any>('Lobby Success');
